var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/TitleActionBar.tsx";
import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack, IconClose } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { ActionBarHeader } from './ActionBarHeader';
import { InAppActionBar } from './InAppActionBar';
const TitleActionBar = ({
  testID,
  title,
  closeBtn,
  onBack
}) => {
  const isLibre = store.getState().env.app === 'libre1';
  if (isLibre) {
    return /*#__PURE__*/React.createElement(InAppActionBar, {
      title: title,
      testID: testID,
      onBack: onBack,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(VStack, {
    style: {
      top: 0,
      left: 0,
      right: 0
    },
    backgroundColor: "$surface.container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ActionBarHeader, {
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    testID: `${testID}.back-btn`,
    onPress: () => {
      onBack ? onBack() : mediator.publish('router:back');
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, closeBtn ? /*#__PURE__*/React.createElement(IconClose, {
    testID: `${testID}.close-btn-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  }) : /*#__PURE__*/React.createElement(IconBack, {
    testID: `${testID}.back-btn-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}.title`,
    color: "$text.100",
    fontSize: "$h4.strong",
    fontWeight: "$h4.strong",
    width: "100%",
    alignSelf: "center",
    textAlign: "center",
    numberOfLines: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, title)));
};
export { TitleActionBar };